'use client';

import clsx from 'clsx';
import { RefCallback, RefObject, SelectHTMLAttributes } from 'react';
import { FieldError } from 'react-hook-form';

interface Props extends SelectHTMLAttributes<HTMLSelectElement> {
  ref?: RefObject<HTMLSelectElement | null> | RefCallback<HTMLSelectElement | null>;
  children: React.ReactNode;
  label?: string;
  error?: FieldError;
  selectClass?: string;
  readOnly?: boolean;
  hint?: string;
}

export function SelectInput({
  ref,
  children,
  label,
  error,
  className,
  selectClass,
  readOnly,
  hint,
  ...restProps
}: Props) {
  return (
    <fieldset className={clsx('fieldset', className)}>
      {readOnly && (
        <input
          type="hidden"
          name={restProps.name}
          value={restProps.value || restProps.defaultValue || ''}
        />
      )}
      {label && (
        <legend className="fieldset-legend flex-wrap items-center justify-start gap-x-3 gap-y-0">
          {label}
          {restProps.required && '*'}
          {error && (
            <span className="validator-hint text-error mt-0">{error?.message?.toString()}</span>
          )}
          {hint && <span className="fieldset-label">{hint}</span>}
        </legend>
      )}
      <select
        ref={ref}
        {...restProps}
        disabled={readOnly || restProps.disabled}
        id={label ? `${label}-validation` : undefined}
        className={clsx('select w-full', error && 'select-error', selectClass)}
      >
        {children}
      </select>
    </fieldset>
  );
}
